export default "__VITE_ASSET__8dd8df18__"